import { render } from "./PreviewPairData.vue?vue&type=template&id=0f1c42dc&scoped=true&bindings={\"label\":\"props\",\"content\":\"props\",\"hideEmptyContent\":\"props\",\"hasBorder\":\"props\",\"contentHtml\":\"setup\"}"
import script from "./PreviewPairData.vue?vue&type=script&lang=ts"
export * from "./PreviewPairData.vue?vue&type=script&lang=ts"

import "./PreviewPairData.vue?vue&type=style&index=0&id=0f1c42dc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0f1c42dc"

export default script